/**重置message，防止重复点击重复弹出message弹框 */
import { Message } from "element-ui";
const showMessage = Symbol("showMessage");
console.log('showMessage',showMessage)
class DoneMessage {
  [showMessage](type, options, single) {
    if (single) {
      console.log(1111111,222222);
      if (document.getElementsByClassName("el-message").length === 0) {
        Message[type](options);
      }
    } else {
      Message[type](options);
    }
  }
  info(options, single = true) {
    this[showMessage]("info", options, single);
  }
  warning(options, single = true) {
    this[showMessage]("warning", options, single);
  }
  error(options, single = true) {
      console.log(1111111,222222);
    this[showMessage]("error", options, single);
  }
  success(options, single = true) {
    this[showMessage]("success", options, single);
  }
}
export const message1 = new DoneMessage();
